import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

import { useIntl } from 'react-intl'

import { SelectField, SelectOption } from '@/lib/core/components/Select'

import { useMyColleagues } from '@/lib/features/Account/api'
import messages from '@/lib/features/SmartShares/components/ShareAssetModal/ShareAssetModal.messages'

import { Container } from './SelectContactFrom.styles'

export type SelectContactFromProps = {
  defaultValue?: SelectOption
}

export const SelectContactFrom = ({ defaultValue }: SelectContactFromProps) => {
  const { formatMessage } = useIntl()
  const { formState } = useFormContext()

  const { data } = useMyColleagues()

  const options = useMemo(
    () =>
      data.results
        .filter(({ user: { shareContact } }) => shareContact)
        .sort((a, b) => {
          const aFullName = `${a.user.firstName} ${a.user.lastName}`.toLowerCase()
          const bFullName = `${b.user.firstName} ${b.user.lastName}`.toLowerCase()
          let res = aFullName.localeCompare(bFullName, 'en', { caseFirst: 'upper' })
          if (res === 0) {
            res = a.user.id - b.user.id
          }
          return res
        })
        .map(
          ({ user: { id, firstName, lastName } }) =>
            ({
              label: `${firstName} ${lastName}`,
              value: id,
            }) as SelectOption,
        ),
    [data],
  )

  return (
    <Container>
      <SelectField
        aria-labelledby="contactFrom"
        name="contactFrom"
        label={'Select your contact for this share'}
        placeholder={formatMessage(messages.organizationToPlaceholder)}
        disabled={formState.isSubmitting}
        required
        selectProps={{
          defaultValue,
          isDisabled: formState.isSubmitting,
          options,
        }}
      />
    </Container>
  )
}
